import * as React from 'react'
import { withNamespaces } from 'react-i18next'
import { connect } from 'react-redux'
import axios from 'axios'
import Spinner from 'react-bootstrap/Spinner'
import EntityManagementService from '../../../../../../api/EntityManagementService'
import { toast } from 'react-toastify'

const DownloadTemplateButton = ({ t, token }) => {
    const [templateDownloadOptions, setTemplateDownloadOptions] = React.useState({
        percent: 0,
        status: null,
        cancelToken: null
    })

    const entityService = new EntityManagementService()

    const handleDownloadTemplate = async () => {
        const cancelToken = axios.CancelToken.source()

        setTemplateDownloadOptions({
            percent: 0,
            status: 'downloading',
            cancelToken: cancelToken
        })

        let loadedBytes = 0

        try {
            const response = await entityService.downloadExcelTemplate({
                onDownloadProgress: (progressEvent) => {
                    loadedBytes = progressEvent.loaded

                    const percentCompleted = Math.round(
                        (loadedBytes * 100) / progressEvent.total
                    )

                    setTemplateDownloadOptions((currentState) => {
                        return {...currentState, percent: percentCompleted}
                    })
                },
                cancelToken: cancelToken.token,
            })
    
            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: '*' })
            )

            const link = document.createElement('a')
    
            link.href = url
            link.setAttribute('download', 'legal_entities.xlsx')
    
            document.body.appendChild(link)
    
            link.click()
            link.remove()

            setTemplateDownloadOptions({
                percent: 0,
                status: 'finished',
                cancelToken: null
            })
        } 
        catch (error) {
            console.log(error)
            let status;
            if (axios.isCancel(error)) {
                status = 'canceled'
                toast(t('Download cancelled.'), {
                    type: 'success',
                })
            } 
            else {
                status = 'faild'
                toast(t('An error occurred while downloading the file.'), {
                    type: 'error'
                })
            }

            setTemplateDownloadOptions({
                percent: 0,
                status: status,
                cancelToken: null
            })
        }
    }

    return (
        <div
            onClick={handleDownloadTemplate}
        >
            {templateDownloadOptions.status === 'downloading' ? (
                <React.Fragment>
                    <Spinner
                        animation='border'
                        variant='primary'
                        size='sm'
                        className='me-1'
                    />
                    {t('Downloading')}{` ${templateDownloadOptions.percent}%`}
                    
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <i className='ri-download-line align-middle me-1' />
                    {t(
                        'Download Excel Template'
                    )}
                </React.Fragment>
            )}
        </div>
    )
}

const mapToState = (state) => {
    const { token } = state.Login

    return {
        token
    }
}

export default withNamespaces()(
    connect(mapToState, {})(
        DownloadTemplateButton
    )
)